import React, { useEffect, useState } from "react";
import { areas } from "../../helpers/areas";
import { useSelector } from 'react-redux';
import { MenuItem } from "@material-ui/core";
import { SelectValidator } from 'react-material-ui-form-validator';

export const CboConveniosPrestacionales = React.memo((props) => {
  const [listaConvenios, setListaConvenios] = useState([]);
  const { items } = useSelector(state => state.conveniosPrestacionales);
  const { idArea: idAreaUsuario } = useSelector((state) => state.auth.areas[0]);

  useEffect(() => {
    if (items?.length > 0) {
      let convFromState = items.map((conv) => {
        return {
          value: conv.idConvenio,
          display: conv.descripcionConvenio,
        };
      });
      setListaConvenios(convFromState);
    }
  }, [items]);
  return (
    <>
      <SelectValidator
        value={listaConvenios?.length > 0 ? props.valor : ''}
        name="id_convenio_prestacional"
        disabled={props.esReactivacion ? false : (props.idPanel === 'idTabConsulta' || props.fromBandejaFamiliar || (props.fromBandeja && idAreaUsuario === areas.Nacional)) ? true : false}
        onChange={(e) => {
          props.manejadorInputChange(e);
        }}
        label="Convenio"
        fullWidth={true}
        margin="normal"
        validators={['required']}
        errorMessages={['Seleccione una opción']}
      >
        <MenuItem value="">
          <em>Seleccione</em>
        </MenuItem>
        {listaConvenios.map((c) => (
          <MenuItem key={c.value} value={c.value}>
            {c.display}
          </MenuItem>
        ))}
      </SelectValidator>
    </>
  );
});
